var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"atom-option"},[_c('AtomsCommonAtomButton',{ref:"optionBtn",class:{ 'option-button': true, active: _vm.internalValue },attrs:{"label":_vm.option.textValue,"icon":_vm.internalValue ? 'minus' : 'plus',"on-click":_vm.handleClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }